import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#fff" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Gain Maximum Value from Our{" "}
              <span>Cloud Cost Optimization Services</span>
            </h2>
            <p>
              While cloud service providers offer native cost management tools,
              these often fall short in terms of capabilities. As a cloud cost
              optimization company, we go beyond these limitations with advanced
              cloud cost optimization solutions, providing a comprehensive and
              accurate overview of your cloud expenditures. This enables you to
              fine-tune and enhance your cloud environment effectively.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Cloud Needs
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Customized Consumption and Expense Assessments</h4>
                  <p>
                    Understanding and predicting your cloud consumption and
                    expenditure is critical for strategic planning. Our cloud
                    cost management team conducts thorough assessments of your
                    historical IT spending patterns and formulates a detailed
                    execution plan. This plan includes prioritizing your cloud
                    sourcing targets, setting realistic savings goals, and
                    implementing specific tactics to achieve them. This ensures
                    you are not only prepared for current demands but also
                    future-proofed.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Comprehensive Expenditure, Usage, and Budgeting Tools</h4>
                  <p>
                    Imagine having all your cloud usage and expenditure data at
                    your fingertips in a customizable dashboard—this is
                    precisely what we offer. Our experts work with you to create
                    personalized dashboards that deliver actionable cloud
                    insights tailored to your organization's needs. These tools
                    empower you to continually monitor and analyze your data,
                    ensuring that your KPIs and business objectives are
                    consistently met.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>24/7 Cloud Services Desk Technical Support</h4>
                  <p>
                    Access to reliable technical support is essential for
                    maintaining operational efficiency and stakeholder
                    satisfaction. Our 24/7 cloud services desk provides
                    round-the-clock support to address your immediate cloud
                    optimization and cost-management inquiries. Our experts are
                    ready to troubleshoot urgent provider issues, ensuring
                    minimal downtime and seamless business operations.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
